/**
 * pdf.js betöltése (legacy build — Safari kompatibilitás).
 * A worker URL csak egyszer állítódik be.
 */
export async function loadPdfjs() {
  const pdfjs = await import("pdfjs-dist/legacy/build/pdf.mjs");
  if (!pdfjs.GlobalWorkerOptions.workerSrc) {
    const workerUrl = await import("pdfjs-dist/legacy/build/pdf.worker.min.mjs?url");
    pdfjs.GlobalWorkerOptions.workerSrc = workerUrl.default;
  }
  return pdfjs;
}
